import request from '@/utils/request'

export function getGroupList(params) {
  return request({
    url: '/sc-basic-merchant-backend/boutique/listener/group/list',
    params,
  });
}

export function getColumnList(params) {
  return request({
    url: '/sc-basic-merchant-backend/boutique/listener/config/list',
    params,
  });
}

export function getStatistics(data) {
  return request({
    url: '/sc-basic-merchant-backend/boutique/listener/data/statistics/list',
    method: 'post',
    data,
  });
}

export function getReport(data) {
  return request({
    url: '/sc-basic-merchant-backend/boutique/listener/data/statistics/report/list',
    method: 'post',
    data,
  });
}
